import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_r9s3742v2a: FaireCollectionEntity = {
  token: "pbc_r9s3742v2a",
  type: "collection",
  name: "paintable notecards",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af9e15287240a9ae339c3fcf50827f8edd4e7986a8115ee3a03daf85ed3af0b2.jpeg",
  itemCount: 20,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.195Z",
    importedBy: "entity-db-import-collections",
  },
};
